import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'startStopStream';
export const useStartStopStreamTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    resume: 'Запустить',
    stop: 'Остановить',
    on_success: 'Действие выполнено',
    on_error: 'Не удалось выполнить действие',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    resume: 'Start',
    stop: 'Stop',
    on_success: 'Action completed',
    on_error: 'Failed to perform action',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    resume: 'Iniciar',
    stop: 'Detener',
    on_success: 'Acción completada',
    on_error: 'No se pudo realizar la acción',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    resume: 'Iniciar',
    stop: 'Parar',
    on_success: 'Ação concluída',
    on_error: 'Falha ao executar a ação',
  },
}) : {}) as Record<string, unknown>;
